import { useEffect } from "react";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { startYearSync } from "./lib/learners";
import { session } from "./lib/session";

export function App() {
  /* The years the account has not been told about, sent at launch and again
     when the phone comes back online. Before this the only thing that drained
     the queue was opening the Account screen, so a year corrected offline sat
     on one phone and never reached the second one. */
  useEffect(() => startYearSync(session), []);

  return <RouterProvider router={router} />;
}
